export function isUniqueMember(newMember: any, existingMembers: any) {
  console.log(newMember, existingMembers)
  return !existingMembers.some(
    (member: any) =>
      member.personalId === newMember.personalId ||
      (member.phone && member.phone === newMember.phone)
  ); // comment
}
